var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Absolute } from '../Absolute';
import { Flex } from '../Flex';
import { Toast } from '../Toast';
import { ThemeProvider } from '../ThemeProvider';
import { Box } from '../Box';
/* istanbul ignore next */
export var ToastContext = createContext({ addToast: function () { }, removeToast: function () { } });
export var useToast = function () {
    return useContext(ToastContext);
};
var id = 0;
function ToastProvider(_a) {
    var children = _a.children, _b = _a.domRootId, domRootId = _b === void 0 ? 'root' : _b, lifespan = _a.lifespan, _c = _a.maxToasts, maxToasts = _c === void 0 ? 3 : _c;
    var _d = useState([]), toasts = _d[0], setToasts = _d[1];
    var addToast = useCallback(function (options) {
        setToasts(function (prevToasts) { return __spreadArray(__spreadArray([], prevToasts, true), [__assign(__assign({}, options), { id: id++ })], false); });
    }, []);
    var removeToast = useCallback(function (id) {
        setToasts(function (prevToasts) {
            return prevToasts.map(function (toast) { return (toast.id === id ? __assign(__assign({}, toast), { removed: true }) : toast); });
        });
    }, []);
    useEffect(function () {
        toasts.forEach(function (toast) {
            if (toast.removed) {
                setTimeout(function () {
                    setToasts(function (prevToasts) { return prevToasts.filter(function (t) { return t.id !== toast.id; }); });
                }, 200);
            }
        });
    }, [toasts, setToasts]);
    var toastsToRender = toasts.slice(0, maxToasts);
    return (React.createElement(ToastContext.Provider, { value: { addToast: addToast, removeToast: removeToast } },
        children,
        createPortal(React.createElement(ThemeProvider, null,
            React.createElement(Absolute, { bottom: 20, width: '100%' },
                React.createElement(Flex, { justifyContent: 'center', width: '100%' },
                    React.createElement(Flex, { flexDirection: 'column-reverse', justifyContent: 'center', minWidth: '300px' }, toastsToRender.map(function (toast, idx) {
                        return (React.createElement(Box, { key: idx, mt: 3 },
                            React.createElement(Toast, __assign({ lifespan: lifespan, onRemoveClick: removeToast }, toast))));
                    }))))), document.getElementById(domRootId))));
}
export default ToastProvider;
//# sourceMappingURL=ToastProvider.js.map